import { atom } from 'recoil';

import { UserUpdateDefaultValues } from '@app/schemas/user';
import { UserUpdate } from '@app/types/user';

export const userUpdateState = atom<UserUpdate>({
  default: UserUpdateDefaultValues,
  key: 'userUpdateState',
});
